module.exports = __webpack_public_path__ + "img/jobpref-topicon.eded3eef.svg";